import React from 'react';
import SVGInline from 'react-svg-inline';

const CoverBackground = ({ template }) => <SVGInline svg={template} />;

export default React.memo(CoverBackground);
